let videoExportRecordingActive = false;

export function setVideoExportRecordingActive(active: boolean) {
  videoExportRecordingActive = active;
}

export function isVideoExportRecordingActive() {
  return videoExportRecordingActive;
}
